import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BixiTableModule } from '@bixi/core/table';
import { MUploadFileListModule } from '@mining/ui/upload-file-list';
import { MUploadSingleFileModule } from '@mining/ui/upload-single-file';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { MUploadFileComponent } from './upload-file.component';
import { MUploadMetaComponent } from './upload-meta.component';

@NgModule({
  declarations: [MUploadFileComponent, MUploadMetaComponent],
  exports: [MUploadFileComponent, MUploadMetaComponent],
  imports: [CommonModule, NzIconModule, NzUploadModule, BixiTableModule, NzButtonModule, MUploadFileListModule, MUploadSingleFileModule]
})
export class MUploadFileModule {}
